import React from 'react'
import { useForm, ValidationError } from '@formspree/react';
import { Container, Title, Hr, Desc, Form, Label, Input, Textarea, Button } from './ContactElements'

const Contact = () => {

    const [state, handleSubmit] = useForm("xgedkqlj");
    if (state.succeeded) {
        return <Container style={{ textAlign: "center", color: 'white', fontSize: "24px" }}>Thank You!</Container>;
    }

    return (

        <Container id="contact">

            <Title>Get In Touch</Title>
            <Hr></Hr>
            <Desc>Have a question or want to work together? Just fill out the form below and I'll get back to you as soon as possible. Let's work together to create something amazing!</Desc>


            <Form onSubmit={handleSubmit}>
                <Label htmlFor="name">Name</Label>
                <Input id="name" type="text" name="name" placeholder="Name" />
                <Label htmlFor="email">Email</Label>
                <Input
                    placeholder="Email"
                    id="email"
                    type="email"
                    name="email"
                />
                <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                />
                <Label htmlFor="message">Message</Label>
                <Textarea
                    placeholder="Your Message"
                    rows="8"
                    id="message"
                    name="message"
                />
                <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                />
                <Button
                    type="submit"
                    disabled={state.submitting}
                >Send Message</Button>
            </Form>


        </Container >
    )
}

export default Contact
